<template>
  <div class="nav-container">
    <div class="nav-content">
      <div class="nav-item" :class="[$route.path.toLowerCase()==`${item.path}`?'active':'',item.path == active?'active':'' ,item.path.indexOf($route.query.key)>-1?'active':'']" v-for="item,index in navList" :key="index" @click="routerPush(item)">
        {{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import services from '../../config/services'
import { mapState } from 'vuex';
import utils from '../../config/utils';

export default {
  data () {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      navList: []
    }
  },
  props: {
    active: {
      type: String
    }
  },

  async mounted () {
    await this.getCategory()
  },
  methods: {
    routerPush (item) {
      if (item.needLogin && !this.loginUserInfo) { // 需要登录的页面且未登录，跳转到信息服务中心登录
        // return window.open(`${services.LOGIN_SERVER}/${this.school_code}/login?from=${window.location.href}`, "_self")
        return window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
      }
      window.open(`/center${item.path}`, item._blank ? "_blank" : "_self")
    },
    // 获取课程分类
    async getCategory () {
      let that = this
      let navList = []
      navList = [{ name: "首页", path: `/${that.school_code}/hzvtc`, sort: 1, }]
      await services.getCategoryList({ root_id: 0, school_code: that.school_code }).then((res) => {
        if (res && res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.id == '106') {
              navList.push({ ...item, name: "党性修养", path: `/${this.school_code}/hzvtc/culture`, sort: 2, })
            }
            if (item.id == '110') {
              navList.push({ ...item, name: "价值引领", path: `/${this.school_code}/hzvtc/value`, sort: 3, })
            }
            if (item.id == '136') {
              navList.push({ ...item, name: "职业素养", path: `/${this.school_code}/hzvtc/profession`, sort: 5, })
            }
            if (item.id == '195') {
              navList.push({ ...item, name: "特色文化", path: `/${this.school_code}/hzvtc/feature`, sort: 6, })
            }
            if (item.id == '121') {
              navList.push({ ...item, name: "家国情怀", path: `/${this.school_code}/hzvtc/feelings`, sort: 4, })
            }

            if (item.id == '152') {
              navList.push({ ...item, name: "生命教育", path: `/${this.school_code}/hzvtc/vita`, sort: 7, })
            }
            // if (item.id == '121') {
            //   navList.push({ name: "生命教育", path: `/${this.school_code}/hzvtc/list_` })
            // }
          })
          navList.push({ name: "学习中心", path: `/${this.school_code}/user/myClass`, _blank: true, needLogin: true, sort: 8, },)
          this.navList = navList.sort((a, b) => a.sort - b.sort)
        }
      })
    },
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    }),
  },
}
</script>

<style lang="less" scoped>
.nav-container {
  width: 100%;
  height: 78px;
  background: #b61e2a;
  position: relative;
  z-index: 100;
  .nav-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .nav-item {
      cursor: pointer;
      flex: 1;
      font-size: 24px;
      color: #fbdea4;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #b61e2a;
        background: linear-gradient(0deg, #dfad6a 0%, #fee3aa 100%);
      }
    }
  }
}
</style>